module.exports = {
	baseURL: "/",
	baseRoute: "/*",
	version: "4091e63",
	host: "https://chemnet.berkeley.edu/chemnet",
	reactHost: "https://chemnet.berkeley.edu",
}
